/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useMemo, useState, memo } from 'react';
import { Button } from 'reactstrap';
// eslint-disable-next-line import/no-named-as-default
import Table from '../../Table';
import CustomSpinner from '../../Spinner/CustomSpinner';

import './styles.css';

const AdminsCGM = memo(({ seletedAdmins, onDelete, loading, selectedValue, noDropdownValue }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    let filteredAdmins = [...seletedAdmins];
  
    if (selectedValue?.email) {
      filteredAdmins = filteredAdmins.filter(item => item?.email === selectedValue.email);
    } else if (noDropdownValue?.length) {
      filteredAdmins = filteredAdmins.filter(item => item?.email?.includes(noDropdownValue[0]));
    }
  
    setData(filteredAdmins || []);
  }, [seletedAdmins, noDropdownValue, selectedValue]);

  const column = useMemo(
    () => [
      {
        dataIndex: 'email',
        label: 'Email',
        sort: (a, b) => {
          if (a.email < b.email) {
            return -1;
          }
          if (a.email > b.email) {
            return 1;
          }
          return 0;
        },
      },
      {
        dataIndex: 'action',
        label: 'Action',
        render: (_, datum, index) => {
          return (
            <Button outline color="danger" onClick={() => onDelete(datum, index)}>
              <i className="fa fa-trash" />
            </Button>
          );
        },
      },
    ],
    [data],
  );
  if (data)
    return (
      <div className="mt-3">
        {loading ? (
          <div className="set-height">
            <CustomSpinner />
          </div>
        ) : (
          <>
            <Table 
              data={data}
              column={column}
              showPagination
              noDataText={'User not found in Group. Click the Add Admins button to add this user to this group.'}
            />
            <div className="mt-3 color-grey">
              <p>Total Users in Group: {seletedAdmins?.length}</p>
            </div>
          </>
        )}
      </div>
    );
  return (
    <div className="mt-3">
      <div className="set-height">
        <h1>No Data Found</h1>
      </div>
    </div>
  );
});

export default AdminsCGM;
